var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-container"},[_c('div',{ref:"amount",staticClass:"chart-canvas"}),_c('img',{staticClass:"banner",attrs:{"src":require("@/assets/images/bg-pic.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }